import React from 'react';
import moment from 'moment';
import { CustomDatePicker } from '../../../components/DateTimePicker';
import { CustomTextField } from '../../../components/Textfield';
import { FileUploader, LightBoxImage } from '../../../components/UI';
import { showMessage } from '../../../utils/helper';
import {
    FieldRow,
    RejectReasonRow,
    formatDob,
    verifyKYCStyles,
} from './verifyKYCHeplers';
import { Box, Grid, Tooltip, Typography } from '@material-ui/core';
import { LinkOffOutlined, LinkOutlined } from '@material-ui/icons';
import DoneAllOutlinedIcon from '@material-ui/icons/DoneAllOutlined';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import CancelPresentationOutlinedIcon from '@material-ui/icons/CancelPresentationOutlined';
import {
    CheckMarkGreen,
    CrossMarkIcon,
    ExclaimIcon,
} from '../../../assets/svg';
import FileUploaderTyped from '../../../components/UI/FileUploader/FileUploaderTyped';
import {
    KycImageRevealRow,
    useRevealedImage,
} from '../../../components/KYC/reveal';
import { isDigilockerVerified } from '../../../utils/appHelper';
interface AadhaarCardStateCardProps {
    payload: any;
    setPayload: Function;
}

const AadhaarCardStateCard: React.FC<AadhaarCardStateCardProps> = ({
    payload,
    setPayload,
}) => {
    // A live UNBLUR_IMAGE grant swaps in the raw object; otherwise this is whatever
    // the API served (the blurred variant, or nothing while masking is pending).
    const revealedFrontImage = useRevealedImage(
        payload?.id,
        payload?.imageFront,
        'FRONT',
    );
    const revealedBackImage = useRevealedImage(
        payload?.id,
        payload?.imageBack,
        'BACK',
    );
    const styles = verifyKYCStyles({});
    const isDocumentIdCreated = !!payload?.id;
    const isManualVerificationRequired = payload?.manualVerificationRequired;
    const isApproved = payload?.approvalStatus === 'APPROVED';
    const isRejected = payload?.approvalStatus === 'REJECTED';
    const isPending = !isApproved && !isRejected;
    const isDocumentNumberMatching = !!payload?.isDocumentNumberMatching;
    const isAadharDobMatching = !!payload?.isDobMatching;
    const enableUpdate = !isApproved;
    let isAadhaarVerifiedByDigiLocker = isDigilockerVerified(payload);
    /*!isDocumentIdCreated ||
        (isManualVerificationRequired &&
            (!isDocumentNumberMatching || !isAadharDobMatching));*/
    console.log(
        'AadhaarCardStateCard payload:',
        isManualVerificationRequired,
        enableUpdate,
        payload,
    );
    const isError =
        isManualVerificationRequired &&
        isPending &&
        (!isDocumentNumberMatching || !isAadharDobMatching);

    const statusText = !!isAadhaarVerifiedByDigiLocker
        ? 'Verified by Digilocker'
        : !isDocumentIdCreated
          ? ''
          : isApproved
            ? 'Verified'
            : isRejected
              ? 'Rejected'
              : isManualVerificationRequired &&
                  (!isDocumentNumberMatching || !isAadharDobMatching)
                ? 'Manual Verification Required'
                : '';

    const statusColor = !isDocumentIdCreated
        ? 'orange'
        : isApproved
          ? '#4caf50'
          : isRejected
            ? '#f44336'
            : isManualVerificationRequired &&
                (!isDocumentNumberMatching || !isAadharDobMatching)
              ? '#f44336'
              : '';

    const renderTopIcons = () => (
        <Box display="flex" alignItems="baseline" ml="2px">
            {!!payload?.panVerified && (
                <>
                    <Tooltip
                        title={!!payload?.linked ? 'Linked' : 'Not Linked'}
                        placement="top"
                    >
                        {!!payload?.linked ? (
                            <LinkOutlined className={styles.successIconStyle} />
                        ) : (
                            <LinkOffOutlined
                                className={styles.errorIconStyle}
                            />
                        )}
                    </Tooltip>

                    <Tooltip
                        title={
                            !!payload?.verified ? 'Verified' : 'Not Verified'
                        }
                        placement="top"
                    >
                        {!!payload?.verified ? (
                            <DoneAllOutlinedIcon
                                className={styles.successIconStyle}
                            />
                        ) : (
                            <CancelPresentationOutlinedIcon
                                className={styles.errorIconStyle}
                            />
                        )}
                    </Tooltip>

                    {!!payload?.centralDobMismatch?.length && (
                        <Tooltip
                            title={`Verified DOB Mismatch - ${payload?.centralDobMismatch}`}
                            placement="top"
                        >
                            <AccountCircleOutlinedIcon
                                className={styles.errorIconStyle}
                            />
                        </Tooltip>
                    )}
                </>
            )}

            {!!payload?.ocrResponseCode &&
                ['435', '436'].includes(payload?.ocrResponseCode) && (
                    <Tooltip
                        title={
                            payload?.ocrResponseCode === '435'
                                ? 'Flagged - Not a Live Document'
                                : 'Flagged - Invalid Photo/Document'
                        }
                        placement="top"
                    >
                        <WarningRoundedIcon className={styles.errorIconStyle} />
                    </Tooltip>
                )}
        </Box>
    );

    const scannedId = payload?.autoKycDocumentNo;
    const enteredId = payload?.documentNo ?? '';
    const scannedDobRaw = payload?.autoKycDocumentDob;
    const enteredDobRaw = payload?.dob;

    return (
        <Grid
            item
            xs={6}
            className={
                isError
                    ? styles.gridItemContainerWithErrorBorder
                    : styles.gridItemContainer
            }
        >
            <Box
                width="100%"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Box display="flex" alignItems="center">
                    <Typography className={styles.title} variant="h6">
                        Aadhaar Details
                    </Typography>
                    {!!isDocumentIdCreated && renderTopIcons()}
                </Box>

                <Box display="flex" alignItems="center" justifyContent="center">
                    <Typography
                        style={{
                            fontWeight: 700,
                            marginLeft: 5,
                            color: statusColor,
                            fontSize: 14,
                        }}
                        variant="h6"
                        component="span"
                        gutterBottom
                    >
                        {statusText}
                    </Typography>
                    <Box ml="0.2rem">
                        {isApproved ? (
                            <CheckMarkGreen style={{ width: '16px' }} />
                        ) : isRejected ? (
                            <CrossMarkIcon style={{ width: '16px' }} />
                        ) : null}
                    </Box>
                </Box>
            </Box>

            {isRejected && !!payload?.rejectReason && (
                <Box style={{ width: '100%', marginTop: 8 }}>
                    <RejectReasonRow reason={payload?.rejectReason} />
                </Box>
            )}

            {/* Body: show different layout if manual verification with mismatch vs normal view */}
            <Box style={{ width: '100%', marginTop: 8 }}>
                {!!payload?.profileImageLink && (
                    <LightBoxImage
                        imageStyles={{
                            height: '120px',
                            objectFit: 'contain',
                            padding: 0,
                            margin: 0,
                        }}
                        source={payload?.profileImageLink}
                    />
                )}
                {/* ID row */}
                {!!isDocumentIdCreated && (
                    <FieldRow
                        label={scannedId ? 'Scanned Id:' : 'Entered Id:'}
                        scannedValue={scannedId}
                        enteredValue={enteredId}
                        showEdited={
                            !!scannedId &&
                            !!enteredId &&
                            !!payload?.docNumberMismatch
                        }
                        showWarning={!isDocumentNumberMatching}
                        documentId={payload?.id}
                        documentType={'AADHAR'}
                        revealable={payload?.revealable}
                        revealSubject={'Aadhaar number'}
                    />
                )}

                {/* DOB row */}
                {!!isDocumentIdCreated && (
                    <FieldRow
                        label={scannedDobRaw ? 'Scanned DOB:' : 'Entered DOB:'}
                        scannedValue={
                            scannedDobRaw ? formatDob(scannedDobRaw) : undefined
                        }
                        enteredValue={
                            enteredDobRaw ? formatDob(enteredDobRaw) : undefined
                        }
                        showEdited={
                            !!scannedDobRaw &&
                            !!enteredDobRaw &&
                            formatDob(scannedDobRaw) !==
                                formatDob(enteredDobRaw)
                        }
                        showWarning={!isAadharDobMatching}
                    />
                )}

                {/* If manual verification with mismatch show editable read-only field as before */}
                {enableUpdate ? (
                    <Box width={'100%'}>
                        <CustomTextField
                            value={enteredId}
                            onChange={(e: any) =>
                                setPayload({
                                    ...payload,
                                    documentNo: e?.target?.value?.trim(),
                                })
                            }
                            label="Aadhaar Number"
                            variant="outlined"
                            style={{
                                width: '100%',
                                marginBottom: 16,
                                marginTop: 8,
                            }}
                            InputProps={{
                                readOnly: !enableUpdate,
                                //endAdornment: <ExclaimIcon />,
                            }}
                        />
                    </Box>
                ) : null}
            </Box>

            <KycImageRevealRow
                documentId={payload?.id}
                documentType={'AADHAR'}
                imageRevealable={payload?.imageRevealable}
                imageUnmasked={payload?.imageUnmasked}
                documentKeys={['FRONT', 'BACK']}
                subject={'Aadhaar image'}
            />

            {!isAadhaarVerifiedByDigiLocker && (
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent={'space-between'}
                    width={'100%'}
                >
                    <Box width={'48%'}>
                        <FileUploaderTyped
                            labelStyles={{
                                fontSize: '14px',
                                fontWeight: 600,
                            }}
                            disabled={!enableUpdate}
                            defaultValue={revealedFrontImage}
                            flowType="KYC"
                            placeholder={'Upload Aadhaar (Front)'}
                            onFileUploaded={(e: any) => {
                                setPayload({
                                    ...payload,
                                    imageFront: e,
                                });
                            }}
                            onRemoved={(e: any) => {
                                setPayload({
                                    ...payload,
                                    imageFront: null,
                                });
                            }}
                        />
                    </Box>
                    <Box width={'48%'}>
                        <FileUploaderTyped
                            labelStyles={{
                                fontSize: '14px',
                                fontWeight: 600,
                            }}
                            disabled={!enableUpdate}
                            defaultValue={revealedBackImage}
                            flowType="KYC"
                            placeholder={'Upload Aadhaar (Back)'}
                            onFileUploaded={(e: any) => {
                                setPayload({
                                    ...payload,
                                    imageBack: e,
                                });
                            }}
                            onRemoved={(e: any) => {
                                setPayload({
                                    ...payload,
                                    imageBack: null,
                                });
                            }}
                        />
                    </Box>
                </Box>
            )}
        </Grid>
    );
};

export default AadhaarCardStateCard;
